// The fiscal software version, under every tab (LNE/BYCYB référentiel v1.8, E21: the major and minor numbers
// « aisément accessibles depuis l'interface utilisateur standard »; P3 brief §11.6). It is the database's
// `pms_fiscal_version()` — the value every fiscal document records — never a constant of this bundle, which could
// drift from the documents it would claim to describe.

import { useEffect, useState } from 'react';
import { usePms } from './PmsProvider.js';

export function FiscalVersionLine() {
  const { fiscalVersion } = usePms();
  const [version, setVersion] = useState<string | null>(null);
  useEffect(() => {
    let live = true;
    void fiscalVersion.read().then((r) => {
      if (live && r.ok) setVersion(r.value);
    });
    return () => {
      live = false;
    };
  }, [fiscalVersion]);
  if (!version) return null;
  return (
    <footer className="pms-fiscal-version muted" data-testid="fiscal-version">
      Logiciel d’encaissement — version fiscale {version}
    </footer>
  );
}
